

export const REASON_DESCRIPTIONS = [
    "Too expensive",
    "Not longer needed",
    "Didn't receive welcome letter",
    "Not what I was looking for",
    "I have never subscribed"
]